export const SIMULATOR_GUIDE_CONTENT = [
    {
        "id": "section-1",
        "title": "Section 1: Getting Started – What This Tool Does",
        "content": `### 1.1 What Is the SAFECore Policy Simulator?
The SAFECore Policy Simulator is an interactive financial modeling tool that projects what would happen to American healthcare spending, household costs, government budgets, and economic outcomes if the SAFECore Act became law.

### 1.2 Why You Need This Tool (Not Just Static Estimates)
Most healthcare policy debates rely on static scoring. This simulator is different because it models:
1. **Dynamic Effects Over Time**
2. **Feedback Loops** (Compounding Effects)
3. **Realistic Frictions**
4. **Stress Testing**
5. **Live Exploration of Trade-Offs**`
    },
    {
        "id": "section-2",
        "title": "Section 2: Core Concepts & Mathematical Framework",
        "content": `### 2.1 The Trust Fund
The SAFECore Trust Fund (Section 206) ensures long-term program solvency through automatic stabilization mechanisms. 

**Statutory Minimum**: 5% of outlays.
**Statutory Maximum**: 10% of outlays.

### 2.2 Health Spending Baseline
The baseline is current system trajectory (CMS NHE projections: $6.2T in 2027). SAFECore reduces this through structural reforms and compounding effects.`
    },
    {
        "id": "section-3",
        "title": "Section 3: Live Parameter Adjustment Guide",
        "content": `### 3.1 Financing Tab
* **Individual AGI Tax**: 3.5% base + progressive surtaxes.
* **Employer AGI Tax**: 8.0% base on business income.
* **Evasion**: Modeled at 12% default.

### 3.2 Provider Tab
* **Payment Rates**: Default 1.0x Medicare.
* **IRP Reduction**: Global drug price reference pricing.`
    },
    {
        "id": "section-7",
        "title": "Section 7: Trust Fund & Solvency Mechanics",
        "content": `If reserves drop below 5%, the **Automatic Rate Adjustment Mechanism** triggers:
* Employer: +0.6pp
* Individual: +0.3pp
* Surtax: +0.5pp

The system becomes fully self-funded (0% general fund) by Year 9.`
    },
    {
        "id": "section-10",
        "title": "Section 10: Data Sources & Validation",
        "content": `All data derives from public government sources:
* **CMS NHE**: National Health Expenditures baseline.
* **Medicare Trustees**: Provider payment and admin overhead benchmarks.
* **IRS SOI**: AGI tax base construction.
* **KFF**: Household burden and medical debt statistics.`
    }
];